import { motion } from 'framer-motion'
import React from 'react'
import { curtainVariants } from '../../animations/variants'
import { theme } from '../../global/_theme'
import Signet from '../Signet'
import './styles.scss'

const PageTransition = ({ location }) => {
  const isInitialRender = location.key === undefined || location.key === '' || location.key === 'initial'

  return (
    <>
      <motion.div
        initial="visible"
        animate="hidden"
        variants={curtainVariants}
        className="page-transition"
        style={{ display: isInitialRender ? 'none' : 'flex' }}
      >
        <motion.div
          initial={{ y: '0vh' }}
          animate={{ y: '-100vh' }}
          transition={{ duration: theme.duration.raw.pageTransition }}
        >
          <Signet variant="solid" size={72} />
        </motion.div>
      </motion.div>
      <motion.div initial="initial" exit="visible" variants={curtainVariants} className="page-transition">
        <motion.div
          initial={{ y: '100vh' }}
          exit={{ y: '0vh' }}
          transition={{ duration: theme.duration.raw.pageTransition }}
        >
          <Signet variant="solid" size={72} />
        </motion.div>
      </motion.div>
    </>
  )
}

export default PageTransition
